<template>
    <div class="row">
      <div class="col-md-12">
        <personal-profile-cdc-module
            v-if="project.client.user.person_type === 1 || project.client.user.person_type === 2"
            :person="project.client.fiscal" />
        <business-profile-cdc-module
            v-else
            :person="project.client.fiscal" />
      </div>
    </div>
</template>

<script>
import {mapState} from "vuex";
import PersonalProfileCdcModule from "../../Score/PersonalProfileCdcModule";
import BusinessProfileCdcModule from "../../Score/BusinessProfileCdcModule";

export default {
    name: "ScoreTab",
    components: {BusinessProfileCdcModule, PersonalProfileCdcModule},
    props: {
      rfc: {
          type: String,
          require: true
      }
    },
    computed: {
      ...mapState("projects", ["project"]),
    },
    data: () => ({
      preApproveModelResult: {},
    })
}
</script>

<style scoped>

</style>
